<template>
  <div>
    <admin-offer-expandable-panel />
    <order-details-for-order-item :data="data" v-if="data !== null">
      <v-tooltip bottom>
        {{ $t("travelService.goToOrder") }}
        <template #activator="{on}">
          <v-btn :to="'/admin/travel-service/edit/' + data.id" class="mx-0" icon v-on="on" small>
            <v-icon small>fa-file-invoice</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
    </order-details-for-order-item>

    <order-item-parameters :type="type" :order-item="data.orderItem" />

    <v-row class="mb-2" v-if="!$store.state.AdminTravelService.isOfferReadonly">
      <v-col cols="10">
        <v-alert color="error darken-4" outlined>
          Jeśli parametry zapytania nie pozwalają na wycenę możesz zadać dodatkowe pytanie zamawiającemu. Aby to zrobić skorzystaj z przycisku wiadomości po
          prawej stronie.
          <span class="font-weight-bold">Funkcjonalność ta powinna być wykorzystywana jedynie w przypadku gdy nie da się przygotować oferty.</span>
          Jeśli nie wiesz, jaka opcja byłaby dla klienta najkorzystniejsza przygotuj poniżej kilka opcji do wyboru.
        </v-alert>
      </v-col>
      <v-col cols="2" class="pa-4" style="text-align: center;">
        <a @click="isMessagesEnabled = true">
          <v-icon size="80">email</v-icon>
        </a>
      </v-col>
    </v-row>

    <message-list
      class="mb-3"
      v-if="isMessagesEnabled || data.messages.length > 0"
      :travel-service-order-id="data.id"
      :travel-service-order-item-id="data.orderItem.id"
      :start-messages="data.messages"
    />

    <h2>Lista ofert</h2>

    <v-form ref="form" v-model="isValid">
      <v-row>
        <v-col cols="8">
          <v-tabs show-arrows slider-color="primary" v-model="selectedTab">
            <template v-for="(itemServiceOffer, n) in serviceOffer">
              <!-- eslint-disable-next-line -->
              <v-tab>
                Opcja {{ n + 1 }}
                <v-tooltip bottom v-if="!$store.state.AdminTravelService.isOfferReadonly">
                  <template #activator="{on}">
                    <v-btn @click="duplicate(itemServiceOffer)" icon v-on="on">
                      <v-icon class="font-weight-regular" small>fa-copy</v-icon>
                    </v-btn>
                  </template>
                  Zduplikuj opcję
                </v-tooltip>
              </v-tab>
            </template>
            <div aria-selected="false" role="tab" class="v-tab" @click="addServiceOffer" v-if="!$store.state.AdminTravelService.isOfferReadonly">
              Dodaj opcję
            </div>
          </v-tabs>
        </v-col>
        <v-spacer />
        <v-col cols="2">
          <v-btn
            @click="removeCurrentServiceOffer()"
            class="hidden-sm-and-down grey"
            dark
            style="width: 95%"
            v-if="!$store.state.AdminTravelService.isOfferReadonly"
          >
            Usuń aktualną opcję
          </v-btn>
        </v-col>
      </v-row>

      <v-tabs show-arrows slider-color="primary" v-model="selectedTab" class="no-tabs">
        <template v-for="itemServiceOffer in serviceOffer">
          <!-- eslint-disable-next-line -->
          <v-tab-item class="mt-3">
            <offer-item-form
              :is-baggage-field-required="isBaggageFieldRequired"
              :service-offer.sync="itemServiceOffer"
              :remove-service-function="() => removeServiceOffer(itemServiceOffer)"
              :type="type"
              :return-date="data.orderItem.return_date"
            >
              <amount-input
                :model.sync="itemServiceOffer.price"
                :rules="[isRequired]"
                label="Cena łącznie*"
                :readonly="$store.state.AdminTravelService.isOfferReadonly"
              />
              <currency-select
                :model.sync="itemServiceOffer.currency"
                :rules="[isRequired]"
                label="Waluta*"
                :readonly="$store.state.AdminTravelService.isOfferReadonly"
              />
              <fieldset class="custom-fieldset">
                <legend>Wymagane dane</legend>
                <v-checkbox
                  :readonly="$store.state.AdminTravelService.isOfferReadonly"
                  class="my-0 py-0"
                  label="Email"
                  v-model="itemServiceOffer.is_email_required"
                />
                <!-- <v-checkbox :readonly="$store.state.AdminTravelService.isOfferReadonly" class="my-0 py-0" label="Telefon" v-model="itemServiceOffer.is_phone_required"></v-checkbox>-->
                <v-checkbox
                  :readonly="$store.state.AdminTravelService.isOfferReadonly"
                  class="my-0 py-0"
                  label="Nr dok. toż."
                  v-model="itemServiceOffer.is_document_number_required"
                />
                <v-checkbox
                  :readonly="$store.state.AdminTravelService.isOfferReadonly"
                  class="my-0 py-0"
                  label="Dok. ważny do"
                  v-model="itemServiceOffer.is_document_expire_required"
                />
                <v-checkbox
                  :readonly="$store.state.AdminTravelService.isOfferReadonly"
                  class="my-0 py-0"
                  label="Miejsce wyst."
                  v-model="itemServiceOffer.is_document_issue_place_required"
                />
                <v-checkbox
                  :readonly="$store.state.AdminTravelService.isOfferReadonly"
                  class="my-0 py-0"
                  label="Data ur."
                  v-model="itemServiceOffer.is_birth_date_required"
                />
                <v-checkbox
                  :readonly="$store.state.AdminTravelService.isOfferReadonly"
                  class="my-0 py-0"
                  label="Drugie imię"
                  v-model="itemServiceOffer.is_middle_name_required"
                />
                <v-checkbox
                  :readonly="$store.state.AdminTravelService.isOfferReadonly"
                  class="my-0 py-0"
                  label="Obywatelstwo"
                  v-model="itemServiceOffer.is_nationality_required"
                />
                <v-checkbox
                  :readonly="$store.state.AdminTravelService.isOfferReadonly"
                  class="my-0 py-0"
                  label="Miejsce pobytu"
                  v-model="itemServiceOffer.is_residence_address_required"
                />
              </fieldset>
            </offer-item-form>
          </v-tab-item>
        </template>
      </v-tabs>
    </v-form>
    <v-alert
      :value="true"
      outlined
      color="error darken-3"
      v-if="data.travel_service_offer_changes_behavior === changeAcceptanceType.INFORM_AFTER_CHANGE && !$store.state.AdminTravelService.isOfferReadonly"
    >
      Ten klient <b>będzie informowany o każdej zmianie</b> w ofercie po jej zapisaniu i wysłaniu. Sprawdź czy uzupełniłeś wszystkie dane i czy są one poprawne.
      Będziesz mógł jedynie załączyć plik z rezerwacją.
    </v-alert>
    <v-alert
      :value="true"
      outlined
      color="error darken-3"
      v-if="data.travel_service_offer_changes_behavior === changeAcceptanceType.ACCEPTANCE_NEEDED && !$store.state.AdminTravelService.isOfferReadonly"
    >
      Każda zmiana w ofercie po wybraniu przez tego klienta <b>musi być ponownie akceptowana</b>. Sprawdź czy uzupełniłeś wszystkie dane i czy są one poprawne.
      Będziesz mógł jedynie załączyć plik z rezerwacją.
    </v-alert>
    <v-card text flat>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="cancel" color="blue darken-1" text>Anuluj</v-btn>
        <template v-if="!$store.state.AdminTravelService.isOfferReadonly">
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="previewPDF" color="blue darken-1" text>Podgląd PDF</v-btn>
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>Zapisz i wyślij </v-btn>
        </template>
        <v-btn
          v-if="data.orderItem.status === itemStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL"
          :disabled="$store.getters['Ajax/loading']"
          @click="cancelledBooking"
          color="blue darken-1"
          text
        >
          Zapisz jako odwołane
        </v-btn>
      </v-card-actions>
    </v-card>
    <AdminOfferHistory :service-offer="serviceOffer" />
  </div>
</template>

<script>
import AdminOfferHistory from "../../../components/TravelService/AdminOfferHistory";
import OfferItemForm from "../../../components/TravelService/Admin/OfferItemForm/OfferItemForm";
import AmountInput from "../../../components/CustomInputComponents/AmountInput";
import CurrencySelect from "../../../components/CustomInputComponents/CurrencySelect";
import travelServiceOrderItemPartFactory from "../../../models/travelOrder/formPartFactory";
import downloadFile from "../../../repository/downloadFile";
import OrderItemParameters from "../../../components/TravelService/Admin/OrderItemParameters";
import MessageList from "../../../components/MessageList";
import OrderDetailsForOrderItem from "../../../components/TravelService/OrderDetailsForOrderItem";
import { itemsStatus as itemStatus } from "../../../staticData/ServiceOrder";
import { changeAcceptanceType } from "../../../staticData/TravelServiceTypes";
import AdminOfferExpandablePanel from "./AdminOfferExpandablePanel";

export default {
  name: "AdminTravelServiceItemEdit",
  components: {
    AdminOfferExpandablePanel,
    OrderDetailsForOrderItem,
    MessageList,
    OrderItemParameters,
    CurrencySelect,
    AmountInput,
    OfferItemForm,
    AdminOfferHistory
  },
  data: () => ({
    changeAcceptanceType,
    itemStatus,
    isMessagesEnabled: false,
    isValid: true,
    isReturnRouteEditing: 0,
    data: {
      messages: [],
      additional_parameters: [],
      id: null,
      company: "",
      contractor_name: "",
      contractor_tin: "",
      contractor_country: "",
      contractor_short_name: "",
      contractor_region: "",
      contractor_city: "",
      created_by_phone: null,
      contractor_street_and_number: "",
      contractor_postal_code: "",
      contractor_mail_addresses: "",
      phone_numbers: null,
      created_by_name: null,
      created_at: null,
      service_order_comment: null,
      orderItem: {
        start_location: null,
        startLocationText: null,
        end_location: null,
        endLocationText: null,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        car_class: null,
        return_date: null,
        return_time: null,
        seat_class: null,
        is_baggage: null,
        room_type: null,
        parking_required: null,
        users: [],
        cost_centre: null,
        status: null,
        params: null,
        name: null,
        comment: null,
        type: null
      }
    },
    serviceOffer: [],
    simpleEditor: false,
    serviceItemOrder: {},
    selectedTab: []
  }),
  created() {
    this.axios.get("/admin/travel-service-admin/get-service-order-item?id=" + this.$route.params.id).then(resp => {
      this.data = resp.data;
      let services = JSON.parse(JSON.stringify(resp.data.responses));
      for (let service of services) {
        if (service.parts.length === 0) {
          this.addServicePart(service);
          service.simpleEditor = true;
        } else {
          service.simpleEditor = false;
        }
        service.price = service.price.toString();
        this.serviceOffer.push(service);
      }
      //this.serviceOffer = services;
      if (this.serviceOffer.length === 0) {
        this.addServiceOffer();
        // if (typeof (resp.data.orderItem.return_date) !== 'undefined' && (resp.data.orderItem.return_date != null) && (resp.data.orderItem.return_date.length > 0)) {
        //     this.addServiceOffer();
        //     this.serviceOffer[1].is_return_route = 1;
        // }
      }
    });

    this.selectedTab = 0;
  },
  methods: {
    revalidateReturnRoute() {
      for (let checkbox of this.$refs.checkboxReturnRoute) {
        checkbox.validate();
      }
    },
    validateIsReturnRouteSet(item) {
      let toRoute = false;
      let fromRoute = false;
      for (let part of item.parts) {
        if (part.is_return_route === false) {
          toRoute = true;
        } else {
          fromRoute = true;
        }
      }
      return (toRoute && fromRoute) || "Wymagana jest przynajmniej jedna trasa tam i jedna powrotna";
    },
    previewPDF() {
      if (this.$refs.form.validate()) {
        downloadFile("admin/travel-service-admin/preview-service-order-item-response", "POST", {
          travelServiceOrder: this.$route.params.id,
          options: this.serviceOffer
        });
      } else {
        this.$store.dispatch("snackbarPush", {
          text: "W formularzu są błędy, sprawdź wszystkie opcje",
          color: "error",
          position: "down"
        });
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.serviceOffer.length < 2) {
          this.$store
            .dispatch("confirmDialog", {
              content: "Czy na pewno chcesz dodać ofertę z tylko jedną opcją do wyboru? ",
              title: "Jesteś pewien?"
            })
            .then(() => this.saveRequest())
            .catch(() => {});
        } else {
          this.saveRequest();
        }
      } else {
        this.$store.dispatch("snackbarPush", {
          text: "W formularzu są błędy, sprawdź wszystkie opcje",
          color: "error",
          position: "down"
        });
      }
    },
    cancelledBooking() {
      this.$store
        .dispatch("confirmDialog", {
          content: "Czy na pewno chcesz zapisać ofertę jako odwołaną?",
          title: "Jesteś pewien?"
        })
        .then(() => {
          this.axios.post("admin/travel-service-admin/save-service-order-item-as-cancelled", { travelServiceOrderItemId: this.$route.params.id }).then(() => {
            this.$router.go(-1);
          });
        })
        .catch(() => {});
    },
    saveRequest() {
      this.axios
        .post("/admin/travel-service-admin/save-service-order-item-response", {
          travelServiceOrder: this.$route.params.id,
          options: this.serviceOffer
        })
        .then(() => {
          this.$router.go(-1);
          //this.$router.push({path: '/admin/order-service-by-type/' + this.$route.params.type});
        });
    },
    cancel() {
      this.$router.back();
    },
    getHourText(hour) {
      return hour != null && hour.length > 3 ? hour : "nie sprecyzowano";
    },
    isRequired(v) {
      return (v != null && v.length > 0) || "Pole wymagane";
    },
    isBaggageFieldRequired(v) {
      return (this.type !== "flight" && this.type !== "low-cost") || (v != null && v.length > 0) || this.data.orderItem.is_baggage !== 1 || "Pole wymagane";
    },
    addServicePart(serviceItem) {
      let formPart = travelServiceOrderItemPartFactory(this.type);
      serviceItem.parts.push(formPart);
    },
    duplicate(itemServiceOffer) {
      let newServiceOffer = JSON.parse(JSON.stringify(itemServiceOffer));
      delete newServiceOffer.id;
      this.serviceOffer.push(newServiceOffer);
      this.selectedTab = this.serviceOffer.length - 1;
    },
    removeServicePart(serviceItemIndex, servicePartIndex) {
      if (this.serviceOffer[serviceItemIndex].parts.length < 2) {
        this.$store.dispatch("snackbarPush", {
          text: "Opcja musi mieć przynajmniej jedną usługę",
          color: "error",
          position: "down"
        });
      } else {
        this.serviceOffer[serviceItemIndex].parts.splice(servicePartIndex, 1);
      }
    },
    addServiceOffer() {
      let newServiceOffer = {
        html: null,
        price: null,
        currency: null,
        is_email_required: false,
        is_phone_required: true,
        is_document_number_required: false,
        is_document_expire_required: false,
        is_birth_date_required: false,
        is_middle_name_required: false,
        is_nationality_required: false,
        is_document_issue_place_required: false,
        is_residence_address_required: false,
        is_return_route: this.isReturnRouteEditing,
        simpleEditor: this.type === "other" || this.type === "insurance",
        parts: []
      };
      this.addServicePart(newServiceOffer);
      this.serviceOffer.push(newServiceOffer);
      this.selectedTab = this.serviceOffer.length - 1;
    },
    removeCurrentServiceOffer() {
      this.removeServiceOffer(this.serviceOffer[this.selectedTab]);
    },
    removeServiceOffer(item) {
      if (this.serviceOffer.filter(v => v.is_return_route === this.isReturnRouteEditing).length < 2) {
        this.$store.dispatch("snackbarPush", {
          text: "Musisz przedstawić przynajmniej jedną opcję",
          color: "error",
          position: "down"
        });
      } else {
        this.serviceOffer.splice(this.serviceOffer.indexOf(item), 1);
      }
    }
  },
  computed: {
    itemOrderId() {
      return this.$route.params.id;
    },
    type() {
      if (this.data.orderItem.type === "flight" && this.data.orderItem.seat_class === "low_cost") {
        return "low-cost";
      }
      return this.data.orderItem.type;
    },
    address() {
      let address = "";
      if (this.data.contractor_street_and_number != null) {
        address += this.data.contractor_street_and_number.toLowerCase() + "\r\n";
      }
      if (this.data.contractor_postal_code != null && this.data.contractor_city != null) {
        address += this.data.contractor_postal_code.toLowerCase() + " " + this.data.contractor_city.toLowerCase() + "\r\n";
      }
      if (this.data.contractor_country != null) {
        address += this.data.contractor_country.toLowerCase();
      }
      return address;
    }
  }
};
</script>

<style>
.small-rating {
  text-align: center;
}

.small-rating > i {
  padding: 0 !important;
}

.route-tab {
  background-color: #0031e2;
}

.route-tab span {
  padding: 5px;
  color: white;
  font-weight: bold;
}

.route-tab-slider {
  background-color: #44d3af !important;
  border-color: #44d3af !important;
  height: 7px;
}
.no-tabs div[role="tablist"] {
  display: none;
}
</style>
